import React from 'react'
import { ListGroupItem, Card, CardHeader, CardBody, ListGroup, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'

export default function ClassesCard({selectedTeacher, selectedClass, classes, select, openModal, educators}) {
  let classesCardBody = null

  if (selectedTeacher && educators) {
    // Classes
    let classesListGroupItems = []
    classesListGroupItems.push(
      <ListGroupItem
        key='classsesListGroupItemAdd'
        onClick={() => openModal('addClass')}
        className='m2clickable'
      >
        + Add Class
      </ListGroupItem>
    )

    const teacher = educators[selectedTeacher]

    if (teacher.classes && classes) {
      let classesList = []
      forOwn(teacher.classes, (check, classId) => {
        if (check) {
          if (classes[classId]) {
            classesList.push(classes[classId])
          }
        }
      })
      if (classesList.length > 0) {
        const sortedClassesList = sortByPropText(classesList, 'name')
        sortedClassesList.forEach((thisClass) => {
          const active = thisClass.id === selectedClass
          classesListGroupItems.push(
            <ListGroupItem
              key={`classesListGroupItem${thisClass.id}`}
              active={active}
              className={'m2clickable'}
              onClick={
                active 
                ? () => openModal(`record&id=${thisClass.id}`) 
                : () => select(thisClass.id)
              }
            >
              {`${thisClass.name ? thisClass.name : thisClass.period}`}
              {active ? <i className="icon-magnifier icons ml-2"></i> : null}
            </ListGroupItem>
          )
        })
      }
    }
    
    classesCardBody = (
      <CardBody>
        <ListGroup>
          {classesListGroupItems}
        </ListGroup>
      </CardBody>
        
    )

  }

  return (
    <Card>
      <CardHeader>
        Classes
      </CardHeader>
      {classesCardBody}
    </Card>
  )


}


// WEBPACK FOOTER //
// ./src/components/Users/ClassesCard.js